<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { AppTextarea, NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineTaskPostpone } from '../../model/modal-discipline-task-postpone.hook'

defineOptions({
  name: 'ModalDisciplineTaskPostpone',
})

const {
  refIsOpen,
  refIsLoading,
  refDateFrom,
  refDateTo,
  refHasReason,
  refReasonOptions,
  refReason,
  refReasonMode,
  refComment,
  setReason,
  setComment,
  closeModal,
  postponeTask,
} = useModalDisciplineTaskPostpone()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    title="Postpone task"
    @click:overlay="closeModal"
  >
    <div class="modal-discipline-task-postpone">
      <AppText
        name="body1"
        color="slate-700"
        tag="div"
      >
        Are you sure you want to postpone this task?
        <br>
        It will be postponed until the next lesson's due date (within 24 hours after the lesson completion).
        <template v-if="refDateFrom && refDateTo">
          <br>
          From this lesson's scheduled time <b>{{ refDateFrom }}</b> to next lesson's scheduled time <b>{{ refDateTo }}</b>.
        </template>
      </AppText>
      <NativeSelect
        v-if="refHasReason"
        name="tutor_reason"
        label="Reason:"
        required
        :mode="refReasonMode"
        :options="refReasonOptions"
        :value="refReason"
        :disabled="refIsLoading"
        @change="setReason"
      />
      <AppTextarea
        name="postpone_comment"
        label="Add comment"
        placeholder="Type here"
        :value="refComment"
        :disabled="refIsLoading"
        @input="setComment"
      />
    </div>
    <template #controls>
      <div class="modal-discipline-task-postpone__controls">
        <BtnPrimary
          text="Confirm"
          color="emerald"
          :disabled="refIsLoading || !refDateTo"
          @click="postponeTask"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsLoading"
          @click="closeModal"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineTaskForm.scss" />
